import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class LocalStorageService {
  private readonly LANG_ITEM_NAME: string = 'LANG';

  setItem(key: string, value: string): void {
    localStorage.setItem(key, value);
  }

  getItem(key: string): string {
    return localStorage.getItem(key);
  }

  removeItem(key: string): void {
    localStorage.removeItem(key);
  }

  clear(): void {
    localStorage.clear();
  }

  setLanguageItem(value: string): void {
    this.setItem(this.LANG_ITEM_NAME, value);
  }

  getLanguageItem(): string {
    return this.getItem(this.LANG_ITEM_NAME);
  }

  removeLangItem(): void {
    this.removeItem(this.LANG_ITEM_NAME);
  }

  getPreferredLanguage(): string {
    return this.getLanguageItem() ? this.getLanguageItem() : navigator.language.split('-')[0].toLowerCase();
  }
}
